import { render, staticRenderFns } from "./word.vue?vue&type=template&id=6275e6c9&scoped=true&"
import script from "./word.vue?vue&type=script&lang=js&"
export * from "./word.vue?vue&type=script&lang=js&"
import style0 from "./word.vue?vue&type=style&index=0&id=6275e6c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6275e6c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6275e6c9')) {
      api.createRecord('6275e6c9', component.options)
    } else {
      api.reload('6275e6c9', component.options)
    }
    module.hot.accept("./word.vue?vue&type=template&id=6275e6c9&scoped=true&", function () {
      api.rerender('6275e6c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/word.vue"
export default component.exports